import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Layout } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useGlobalStore } from 'stores/global'
import { getCorporates } from 'services/corporate.service'
import { Corporate } from 'stores/types/corporate.types'
import { Paginate } from 'stores/types/common.type'
import { convertOffsetToPage } from 'utilities/common'
import { useCorporateStore } from 'stores/corporate'
import { ROLE_ACCESS } from 'constants/accessRole'

import CorporateTable from './components/Table'
import CorporateSearch from './components/Search'
import PermissionAccess from 'components/PermissionAccess'

const Content = Layout.Content

const CorporatePage = () => {
  const navigate = useNavigate()
  const { setPageHeader } = useGlobalStore()
  const { setCorporate } = useCorporateStore()

  const [Corporates, setCorporates] = useState<Corporate[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [pagination, setPagination] = useState<Paginate>({
    offset: 0,
    limit: 10,
    total: 0,
    currentPage: 0,
  })
  const [search, setSearch] = useState<{ keyword: string | undefined }>({
    keyword: undefined,
  })

  useEffect(() => {
    setPageHeader({
      title: 'Corporates',
      subTitle: '',
      onBack: '/corporates',
      backIcon: false,
      extra: [
        <PermissionAccess roles={ROLE_ACCESS.CORPORATE_LIST.CREATE} key={0}>
          <Button
            type='primary'
            shape='default'
            size='large'
            className=''
            icon={<PlusOutlined />}
            onClick={() => clickCreateCorporate()}
          >
            Create Corporate
          </Button>
        </PermissionAccess>,
      ],
    })
    findCorporates()
  }, [])

  const clickCreateCorporate = () => {
    setCorporate(null)
    navigate('/corporate/create')
  }

  const findCorporates = async (param = {}) => {
    setLoading(true)
    const query = {
      ...pagination,
      ...search,
      ...param,
      page: 'LIST_CORPORATES',
      sortBy: 'corporateName.th',
      orderBy: 'ASC',
    }
    const payload = await getCorporates(query)
    if (payload?.status?.code === 200) {
      setCorporates(payload.data)
      setPagination({
        limit: query.limit,
        offset: payload.meta.offset,
        total: payload.meta?.total,
        currentPage: convertOffsetToPage(payload.meta?.offset, payload.meta?.limit),
      })
    }
    setLoading(false)
  }

  const changePage = (page: number, limit: number) => {
    const offset = limit * (page - 1)
    const paginate = {
      ...pagination,
      offset,
      limit,
    }
    setPagination(paginate)
    findCorporates(paginate)
  }

  const onSearch = (searchValues: any) => {
    const paginate = {
      ...pagination,
      offset: 0,
    }
    setPagination(paginate)
    setSearch(searchValues)
    findCorporates({
      ...searchValues,
      ...paginate,
      offset: 0,
    })
  }

  return (
    <>
      <Content>
        <CorporateSearch onSubmit={onSearch} />
      </Content>

      <Content>
        <CorporateTable
          loading={loading}
          dataSource={Corporates}
          pagination={pagination}
          changePage={changePage}
          onRefresh={findCorporates}
        />
      </Content>
    </>
  )
}

export default CorporatePage
